import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-599ab48a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id", "name", "checked", "disabled", "onChange"]

import { computed } from 'vue';

export interface IToggleButtonProps {
    modelValue?: boolean;
    id?: string;
    name?: string;
    disabled?: boolean;
    tag?: string;
    speed?: number;
    colorChecked?: string;
    colorUnchecked?: string;
    colorDisabled?: string;
    switchColorChecked?: string;
    switchColorUnchecked?: string;
    cssColors?: boolean;
    showLabels?: boolean;
    labelChecked?: string;
    labelUnchecked?: string;
    height?: number;
    width?: number;
    margin?: number;
    fontSize?: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ToggleButton',
  props: {
    modelValue: { type: Boolean, default: false },
    id: {},
    name: {},
    disabled: { type: Boolean },
    tag: {},
    speed: { default: 300 },
    colorChecked: { default: 'var(--primary-color-lighter)' },
    colorUnchecked: { default: '#bfcbd9' },
    colorDisabled: {},
    switchColorChecked: { default: 'var(--primary-color)' },
    switchColorUnchecked: { default: 'grey' },
    cssColors: { type: Boolean },
    showLabels: { type: Boolean },
    labelChecked: { default: 'on' },
    labelUnchecked: { default: 'off' },
    height: { default: 22 },
    width: { default: 50 },
    margin: { default: 3 },
    fontSize: {}
  },
  emits: ['update:modelValue', 'change'],
  setup(__props: any, { emit: __emit }) {

function px(value: any) {
    return `${value}px`;
}
function translate3d(x: number | string, y: number | string, z = '0px') {
    return `translate3d(${x}, ${y}, ${z})`;
}
const props = __props;
const emit = __emit;
const toggled = computed({
    get() {
        return props.modelValue;
    },
    set(value) {
        emit('update:modelValue', value);
    }
});
const colorCurrent = computed(() => {
    return toggled.value ? props.colorChecked : props.colorUnchecked;
});
const colorDisabled = computed(() => {
    return props.colorDisabled ? props.colorDisabled : colorCurrent.value;
});
const coreStyle = computed(() => {
    return {
        width: px(props.width),
        height: px(props.height),
        backgroundColor: props.cssColors ? undefined : (props.disabled ? colorDisabled.value : colorCurrent.value),
        borderRadius: px(Math.round(props.height / 2))
    };
});
const switchColorCurrent = computed(() => {
    return toggled.value ? props.switchColorChecked : props.switchColorUnchecked;
});
const buttonRadius = computed(() => px(props.height - props.margin * 2));
const distance = computed(() => px(props.width - props.height + props.margin));
const buttonStyle = computed(() => {
    const transition = `transform ${props.speed}ms`;
    const margin = px(props.margin);
    const transform = toggled.value
        ? translate3d(distance.value, margin)
        : translate3d(margin, margin);
    const background = switchColorCurrent.value;
    return {
        width: buttonRadius.value,
        height: buttonRadius.value,
        transition,
        transform,
        background
    };
});
const labelStyle = computed(() => {
    return {
        lineHeight: px(props.height),
        fontSize: props.fontSize ? px(props.fontSize) : undefined
    };
});
function toggle(event: Event) {
    toggled.value = !toggled.value;
    emit('change', {
        value: toggled,
        tag: props.tag,
        srcEvent: event,
    });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["vue-js-switch", { disabled: _ctx.disabled }])
  }, [
    _createElementVNode("input", {
      type: "checkbox",
      class: "v-switch-input",
      id: _ctx.id,
      name: _ctx.name,
      checked: toggled.value,
      disabled: _ctx.disabled,
      onChange: _withModifiers(toggle, ["stop"])
    }, null, 40, _hoisted_1),
    _createElementVNode("div", {
      class: "v-switch-core",
      style: _normalizeStyle(coreStyle.value)
    }, [
      _createElementVNode("div", {
        class: "v-switch-button",
        style: _normalizeStyle(buttonStyle.value)
      }, null, 4)
    ], 4),
    (_ctx.showLabels)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (toggled.value)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "v-switch-label v-left",
                style: _normalizeStyle(labelStyle.value)
              }, [
                _renderSlot(_ctx.$slots, "checked", {}, () => [
                  _createTextVNode(_toDisplayString(_ctx.labelChecked), 1)
                ])
              ], 4))
            : (_openBlock(), _createElementBlock("span", {
                key: 1,
                class: "v-switch-label v-right",
                style: _normalizeStyle(labelStyle.value)
              }, [
                _renderSlot(_ctx.$slots, "unchecked", {}, () => [
                  _createTextVNode(_toDisplayString(_ctx.labelUnchecked), 1)
                ])
              ], 4))
        ], 64))
      : _createCommentVNode("", true)
  ], 2))
}
}

})